module.exports = __webpack_public_path__ + "static/img/M73K-PF_A.534b36f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/M73K-PF_A.jpg
// module id = vjdM
// module chunks = 0